import AdvancedController from "../lib/advanced-controller"
import { gsap } from 'gsap';
// import ScrollTrigger from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);

export default class Scene01Controller extends AdvancedController {

  static targets = [
    "container",
    "backgroundImage",
    "background",
    "clippingMaskTorch",
    "clippingMaskTypo",
    "torch",
    "slogan",
    "indicator",
    "video",
    "backgroundImageImage"
  ];

  static values = {
    "image": Array
  }

  connect() {
    super.connect();

    const BASE_ANIMATION_TIME = 3;

    // set random image and video
    const rand = Math.floor(Math.random() * 3)
    const randSources = this.imageValue[rand];
    if (this.hasVideoTarget) {
      if (window.innerWidth < 922) {
        // replace video with image
        randSources.video
        const parent = this.videoTarget.parentElement
        parent.removeChild(this.videoTarget)
        const imgEl = document.createElement("img")
        imgEl.setAttribute('src', randSources.imageSm)
        imgEl.setAttribute('alt', '')
        parent.appendChild(imgEl)
      } else {
        // set src
        this.videoTarget.src = randSources.video
      }
    }


    this.backgroundImageImageTarget.src = randSources.image + (window.innerWidth < 767 ? '-sm' : '') + '.webp'

    this.timeline = gsap.timeline({

      onUpdate: this.onUpdate.bind(this),
      scrollTrigger: {
        // trigger: this.containerTarget,
        start: "-64px top",
        pin: this.containerTarget,
        end: "200%",
        scrub: 0.5,
        // markers: { startColor: "green", endColor: "red", fontSize: "12px" }
      }
    });

    const steps = [
      // { el: document.body, to: { overflow: "hidden" } },
      { el: this.indicatorTarget, to: { opacity: 0, scale: 0, duration: BASE_ANIMATION_TIME * 1 }, offset: "<" },
      { el: this.backgroundTarget, to: { opacity: 0, duration: BASE_ANIMATION_TIME }, offset: "<25%" },
      { el: this.clippingMaskTypoTarget, to: { opacity: 0, duration: BASE_ANIMATION_TIME }, offset: "<" },
      { el: [this.clippingMaskTorchTarget], to: { y: 250, x: 50, scale: 200, duration: BASE_ANIMATION_TIME * 1.5, transformOrigin: "center center" }, offset: "<" },
      { el: [this.clippingMaskTypoTarget], to: { y: 250, x: 50, scale: 200, duration: BASE_ANIMATION_TIME * 1.5, transformOrigin: "center 0%" }, offset: "<" },
      { el: this.backgroundImageTarget, to: { scale: 1, duration: BASE_ANIMATION_TIME }, offset: `<` },
      { el: this.torchTarget, to: { opacity: 0.8, filter: "blur(0px)", scale: 1.2, x: 0, duration: BASE_ANIMATION_TIME, ease: 'none' }, offset: "<75%" },
      { el: this.torchTarget, to: { scale: 1.0, duration: BASE_ANIMATION_TIME, ease: 'none' }, offset: ">" },
      { el: this.sloganTarget, to: { right: "5vw", filter: "blur(0px)", opacity: 1, scale: 1, duration: BASE_ANIMATION_TIME, ease: 'none' }, offset: "<0%" },
      { el: document.body, to: { opacity: 1, duration: BASE_ANIMATION_TIME }, offset: null },
    ]

    for (const step of steps) {
      this.timeline.to.apply(this.timeline, [step.el, step.to, step.offset])
    }
  }

  onUpdate() {
    this.sendMessage(this.debugController, 'messageProgress', this.timeline.progress())
  }

  messageDebugInit(debugController) {
    this.debugController = debugController
    this.hasDebugController = true
  }

  messageProgress(progress) {
    this.timeline.pause();
    this.timeline.progress(progress)
  }

  messageTogglePlayPause() {
    if (this.timeline.paused()) {
      this.timeline.play();
    } else {
      this.timeline.pause();
    }
  }

}
